export const FINANCING_THRESHOLD_FOR_COLLATERAL_REQUIREMENT = 0.7
export const HOUSING_COMPANY_SHAREHOLDER_TAX_RATE = 0.015
export const REAL_ESTATE_TAX_RATE = 0.03
export const OTHER_VALUE = 'other'

export const PERCENTAGE_PRECISION_MULTIPLIER = 10_000

export const MIN_EMPLOYMENT_DURATION_YEARS = 1
